import React from 'react';
import styled from 'styled-components';
import Tooltip from "../Tooltip";
import {Badge} from "../UI";
import {Theme} from "@dspworkplace/ui";

const HighlightBadge = styled(Badge)`
    width: 12px;
    height: 12px;
    background: ${Theme.colors.primary};
    cursor: help;

    animation: blink 1.5s ease-in infinite;
    
    @keyframes blink {
        0% {
            box-shadow: 0 0 1px -1px ${Theme.colors.warnings.border}BB;
        }
        70% {
            box-shadow: 0 0 1px 8px ${Theme.colors.warnings.border}BB;
        }
        100% {
            box-shadow: 0 0 1px 11px ${Theme.colors.warnings.border}00;
        }
    }
`;

export default function Highlight({
    content,
    children
}) {
    return <div
        style={{position: "relative", display: "inline-block"}}
    >
        {children}
        <Tooltip content={content} offset={42}>
            <HighlightBadge/>
        </Tooltip>
    </div>
}